import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { CoachMatchingWidget } from "@/modules/coaching/coach-matching/components/CoachMatchingWidget";

const coachMatchingParams = z.object({
  customerId: z.coerce.number().int().positive().optional(),
  email: z.string().email().optional(),
  name: z.string().optional(),
  preSessionNotesEnabled: z
    .union([z.boolean(), z.string()])
    .optional()
    .transform((value) => value === true || value === "true"),
});

export const Route = createFileRoute("/embed/coach-matching")({
  validateSearch: coachMatchingParams,
  component: CoachMatchingWidget,
});
